import React, { useEffect, useState, createContext, useContext } from 'react';
import { translations, Lang } from './translations';
interface LanguageContextType {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: (key: string) => string;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
const STORAGE_KEY = 'meelo_lang';
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [lang, setLangState] = useState<Lang>('ru');
  useEffect(() => {
    // 1. Check URL params
    const params = new URLSearchParams(window.location.search);
    const urlLang = params.get('lang') as Lang | null;
    if (urlLang && ['ru', 'kk', 'en'].includes(urlLang)) {
      setLang(urlLang);
      return;
    }
    // 2. Check localStorage
    const storedLang = localStorage.getItem(STORAGE_KEY) as Lang | null;
    if (storedLang && ['ru', 'kk', 'en'].includes(storedLang)) {
      setLangState(storedLang);
      return;
    }
    // 3. Default to Russian
    setLang('ru');
  }, []);
  const setLang = (newLang: Lang) => {
    setLangState(newLang);
    localStorage.setItem(STORAGE_KEY, newLang);
    document.documentElement.lang = newLang;
  };
  const t = (key: string): string => {
    const langDict = translations[lang] || translations['ru'];
    return langDict[key] || translations['ru'][key] || key;
  };
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-309" data-mp="2m36h6znwo5nq">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}